import type { DeepStringLike } from "../types";
import type { sharedStringsEn } from "./english";

export const sharedStringsEs = {
  /**
   *
   * Shared Strings
   *
   */
  qaReview: {
    coveredProjects: "Proyectos cubiertos",
    needsReview: "Necesita revisión",
    reviewed: "Revisado",
    structures: "Estructuras",
  },
  msaResignBanner: {
    due: "Firma el nuevo Contrato Maestro de Servicios antes del {date} para seguir recibiendo órdenes de trabajo.",
    overdue:
      "Las órdenes de trabajo nuevas están en pausa hasta que firmes el nuevo Contrato Maestro de Servicios. Tus trabajos abiertos continúan.",
    action: "Revisar y firmar",
  },
  auth: {
    error_messages: {
      form_code_incorrect: "Código inválido",
      form_password_length_too_short: "La contraseña es demasiado corta",
      form_password_pwned: "Esa contraseña apareció en una filtración de datos. Elige una diferente.",
      form_password_not_strong_enough: "Esa contraseña es demasiado fácil de adivinar.",
      form_password_validation_failed: "Esa contraseña no cumple con los requisitos.",
      form_password_incorrect: "Correo electrónico o contraseña inválidos",
      form_conditional_param_missing: "Dirección de correo electrónico inválida",
      session_exists: "Ya has iniciado sesión",
      user_locked: "Demasiados intentos. Por favor, inténtalo de nuevo en 59 minutos.",
      user_banned: "Tu cuenta ha sido desactivada. Por favor, contacta al soporte.",
      form_param_format_invalid: "Dirección de correo electrónico inválida",
      form_identifier_not_found: "Correo electrónico o contraseña inválidos",
      verification_not_sent: "Correo de verificación no enviado",
      form_identifier_exists: "Número de teléfono ya está en uso",
      verification_expired: "Ese código expiró. Solicita uno nuevo e inténtalo otra vez.",
      verification_failed: "Demasiados intentos. Prueba con otro método o vuelve a iniciar sesión.",
      not_allowed_access: "Este método de verificación no está habilitado. Contacta a soporte.",
      generic_error: "Algo salió mal. Por favor, inténtalo de nuevo.",
    },
    mfa: {
      lastFactorGuard: "Este es tu único método de verificación. Agrega otro método antes de eliminarlo.",
      lastFactorGuardDescription:
        "Necesitas al menos una aplicación de autenticación o un número de teléfono para la verificación en dos pasos.",
      factorLabel: {
        totp: "Aplicación de autenticación",
        phoneCode: "Mensaje de texto",
        backupCode: "Código de respaldo",
      },
      backupCodes: {
        title: "Códigos de respaldo",
        description:
          "Usa códigos de respaldo para iniciar sesión si pierdes acceso a tu aplicación de autenticación o teléfono.",
        generate: "Generar códigos de respaldo",
        regenerate: "Regenerar códigos",
        download: "Descargar códigos",
        regenerateConfirmTitle: "¿Regenerar códigos de respaldo?",
        regenerateConfirmBody:
          "Tus códigos de respaldo actuales dejarán de funcionar de inmediato. Recibirás un nuevo conjunto de códigos para guardar.",
        codesReady: "Guarda estos códigos en un lugar seguro. Cada código solo se puede usar una vez.",
        codesReadyRegenerated: "Nuevos códigos generados. Tus códigos anteriores ya no funcionan.",
        downloadFileHeader: "Códigos de respaldo de Remi",
        downloadFileNote: "Cada código solo se puede usar una vez.",
      },
      challengeBackupCode: {
        title: "Ingresa un código de respaldo",
        description: "Ingresa uno de tus códigos de respaldo para verificar tu identidad.",
        placeholder: "Código de respaldo",
        submit: "Verificar",
      },
      setup: {
        title: "Verificación en dos pasos requerida",
        enrolledDescription:
          "Tu cuenta tiene la verificación en dos pasos habilitada pero tu sesión actual no ha sido verificada. Cierra sesión e inicia sesión de nuevo para completar la verificación.",
        unenrolledDescription:
          "Tu cuenta requiere verificación en dos pasos. Configura una aplicación de autenticación o verificación por mensaje de texto a continuación para continuar.",
        signOut: "Cerrar sesión",
      },
      enrollmentBanner: {
        hasCredentials: {
          title: "Configura la verificación en dos pasos",
          description:
            "Protege tu cuenta agregando una aplicación de autenticación o verificación por mensaje de texto.",
          action: "Configurar 2FA",
          dismiss: "Posponer",
        },
        needsCredentials: {
          title: "Configura la verificación en dos pasos",
          description:
            "Necesitas agregar un correo electrónico y una contraseña a tu cuenta antes de poder habilitar la verificación en dos pasos.",
          action: "Configurar 2FA",
          dismiss: "Posponer",
        },
      },
    },
  },
} as const satisfies DeepStringLike<typeof sharedStringsEn>;
